import axios from 'axios'

class Products {
    get(filters = {}) {
        return axios({
            method: 'GET',
            url: '/api/v1/products',
            params: {
                ...filters,
            },
        })
    }
}

export default Products
